import { Theme, makeStyles } from "@material-ui/core";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";
import constants from "src/constants";
import { graphLabelArray } from "src/mock/graph";
import { useSelector } from "src/store";
import { createArrayMinMax } from "src/utils/createArray";
interface RateGraphProps {
  name: string;
  uv: number;
  pv: number;
  amt: number;
}

export default ({ dataKey, data, type }) => {
  const [dim, setDim] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  // const xl3 = dim.width >= 1900;
  const xxl = dim.width > 1800;
  const xl = dim.width >= 1400;
  // const lg2 = dim.width >= 1400;
  const lg = dim.width > 960;
  const md = dim.width <= 960 && dim.width > 600;
  const sm = dim.width <= 600;

  const [dataMinimum, setDataMin] = useState(0);
  const [dataMaximum, setDataMax] = useState(0);
  const [planType, setPlanType] = useState("other");
  const [showLabelX, setShowLabelX] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const state = useSelector((state) => state.bkv);

  const [graph, setGraph] = useState({
    min: 0,
    max: 0,
    bb: 0,
  });
  const [createdArray, setCreatedArray] = useState([]);
  const graphHeight = xxl
    ? 380
    : xl
    ? 380
    : lg
    ? 380
    : md
    ? dim.width / 2.4
    : dim.width / 1.6;
  const [pos, setPos] = useState({ x: 0, y: 0, change: true });
  const classes = useStyles(pos);

  useEffect(() => {
    function handleWindowResize() {
      const { innerWidth, innerHeight } = window;
      let winSize = { width: innerWidth, height: innerHeight };
      setDim(winSize);
      setPos({ ...pos, change: true });
    }
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    // console.log('graphData ==>', graphData)
    let diff = 0;
    const min = Math.min(...graphData.map((item) => item.bluebonnet));
    const max = Math.max(...graphData.map((item) => item.gimmicky));
    // console.log('min, max ==>', min, max)
    const minRounded = Math.round(min);
    const maxRounded = Math.round(max);

    diff = maxRounded - minRounded;
    setDataMax(max);
    if (graphData.length > 0) {
      let arrayList = createArrayMinMax(minRounded - diff, maxRounded + diff);
      setCreatedArray(arrayList);
    }
  }, [graphData]);

  useEffect(() => {
    if (graphData.length) {
      const bb = graphData[0]["bluebonnet"];
      const gimArr = graphData.map((item) => item.gimmicky);
      const gim_l = Math.min(...gimArr);
      const gim_g = Math.max(...gimArr);
      const gim_max = Math.max(bb - gim_l, gim_g - bb);
      // console.log('gim_max ==>', gim_max)
      let l = bb - gim_max;
      let g = bb + gim_max;
      // console.log("l ==>", l);
      // console.log("bb ==>", bb, "gim_l ==>", gim_l, "gim_g ==>", gim_g);
      // console.log("g ==>", g);
      setGraph({
        min: l - 1,
        max: g + 1,
        bb: bb,
      });
    }
  }, [graphData]);

  console.log(graphData);

  useEffect(() => {
    if (
      type === "bluebonnet-vs-ev-charging" ||
      type === "bluebonnet-vs-free-nights" ||
      type === "bluebonnet-vs-free-weekends"
    ) {
      setPlanType(type);
      setShowLabelX(true);
    } else {
      setPlanType("other");
      setShowLabelX(false);
    }
  }, [type]);

  useEffect(() => {
    if (
      (state.gimmicky &&
        state.gimmicky.Tiers &&
        planType === "bluebonnet-vs-ev-charging") ||
      planType === "bluebonnet-vs-free-nights" ||
      planType === "bluebonnet-vs-free-weekends"
    ) {
      if (planType === "bluebonnet-vs-ev-charging") {
        let electricityRates = JSON.parse(state.gimmicky.Tiers);
        const ultraOffPeakObject = electricityRates.find(
          (rate) => rate.name === "Ultra off-peak"
        );
        let ultraOffPeak = null;
        if (ultraOffPeakObject) {
          let pricePerKwh = parseFloat(ultraOffPeakObject.price_per_kwh);
          ultraOffPeak = pricePerKwh * 100;
        }

        const OffPeakObject = electricityRates.find(
          (rate) => rate.name === "Off-peak"
        );
        let offPeak = null;
        if (OffPeakObject) {
          let pricePerKwh = parseFloat(OffPeakObject.price_per_kwh);
          offPeak = pricePerKwh * 100;
        }

        const onPeakObject = electricityRates.find(
          (rate) => rate.name === "On-peak"
        );
        let onPeak = null;
        if (onPeakObject) {
          let pricePerKwh = parseFloat(onPeakObject.price_per_kwh);
          onPeak = pricePerKwh * 100;
        }

        let rateArr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
        ].map((hour, index) => {
          if (index === 0) {
            return {
              gimmicky: 0,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          } else if (index < 7) {
            return {
              gimmicky: ultraOffPeak,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          } else if (index < 19) {
            return {
              gimmicky: offPeak,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          } else if (index < 23) {
            return {
              gimmicky: onPeak,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          } else {
            return {
              gimmicky: offPeak,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          }
        });
        setGraphData(rateArr);
      } else if (planType === "bluebonnet-vs-free-nights") {
        let rateArr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
        ].map((hour, index) => {
          if (index < 7) {
            return {
              gimmicky: 0,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          } else if (index < 20) {
            return {
              gimmicky: state.gimmicky.kWh2500,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          } else {
            return {
              gimmicky: 0,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              hour: hour,
            };
          }
        });
        setGraphData(rateArr);
        //setGraphData(graphMockData[planType]);
      } else if (planType === "bluebonnet-vs-free-weekends") {
        let rateArr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
        ].map((day, index) => {
          if (index < 19) {
            return {
              gimmicky: state.gimmicky.kWh2500,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              day: day,
            };
          } else {
            return {
              gimmicky: 0,
              bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
              day: day,
            };
          }
        });
        setGraphData(rateArr);
        //setGraphData(graphMockData[planType]);
      }
      // setGraphData(graphMockData[planType]);
    } else {
      if (data && data.length > 0 && !data[0].gimmicky) {
        let _data = data;
        _data.map((item) => (item.gimmicky = 0));
        return setGraphData(_data);
      }
      setGraphData(data);
    }
  }, [planType, data]);

  if (graphData?.[0]?.gimmicky === 0) {
    return null;
  }

  const getMiddleStepData = (data) => {
    const result = [];

    for (let i = 0; i < data.length - 1; i++) {
      const current = data[i];
      const next = data[i + 1];

      result.push(current);

      const middleKwh = (current.kwh + next.kwh) / 2;
      result.push({
        gimmicky: current.gimmicky,
        bluebonnet: current.bluebonnet,
        kwh: middleKwh,
      });
    }

    // 最后一个点不变
    result.push(data[data.length - 1]);

    return result;
  };

  return (
    <Box width={{ lg: "94%" }} ml="6%" className={classes.root}>
      <ResponsiveContainer width="100%" height={graphHeight}>
        <LineChart
          // width={graphWidth}
          // height={graphHeight}
          data={getMiddleStepData(graphData)}
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: -10,
          }}
        >
          <YAxis
            hide={true}
            tick={false}
            type="number"
            domain={[
              (dataMin) => {
                return graph.min;
              },
              (dataMax) => {
                return graph.max;
              },
            ]}
            // ticks={createArrayMinMax(graph.min, graph.max)}
          />
          {/* <Tooltip /> */}
          <Line
            animationDuration={constants.graphAnimation}
            isAnimationActive={false}
            type="step"
            dot={false}
            dataKey="gimmicky"
            unit="¢"
            name="Gimmicky Rate"
            connectNulls={false}
            stroke="#CCCCCC"
            strokeWidth={sm ? 3 : 4}
            style={{ strokeLinecap: "round" }}
          />
          <Line
            animationDuration={constants.graphAnimation}
            isAnimationActive={false}
            dot={false}
            type="step"
            dataKey="bluebonnet"
            unit="¢"
            name="Bluebonnet Rate"
            stroke="#33AEA0"
            strokeWidth={sm ? 5 : 6}
            style={{ strokeLinecap: "round" }}
            label={<CustomizedLabel pos={pos} setPos={setPos} />}
          />
        </LineChart>
      </ResponsiveContainer>
      {pos.y ? (
        <>
          <Box className={classes.more}>
            <Typography>
              {" "}
              You pay{sm && <br />} <span className="highlight">More</span>
            </Typography>
          </Box>
          <Box className={classes.save}>
            <Typography>
              {" "}
              You {sm && <br />} <span className="highlight">Save</span>
            </Typography>
          </Box>
          {/* <Box className={classes.logo}>
            <img src={logo} alt="logo" />
          </Box> */}
          <Box className={classes.recommended}>
            <Typography className="highlight"> Recommended</Typography>
          </Box>
        </>
      ) : null}

      <Box className={classes.ticks}>
        {graphLabelArray[planType].map((usage) => (
          <Typography sx={{ fontSize: "10px" }}>
            {usage}
            {sm && <br />}
          </Typography>
        ))}
      </Box>

      <Box className={classes.ticksY}>
        {[
          graph.max.toFixed(),
          (graph.bb + (graph.max - graph.bb) / 2).toFixed(),
          graph.bb,
          (graph.bb / 2).toFixed(),
          0,
        ].map((usage) => (
          <Typography sx={{ fontSize: "10px" }}>
            {usage}
            {sm && <br />}
          </Typography>
        ))}
      </Box>

      <Box className={classes.labelY}>
        <Typography sx={{ fontSize: "10px" }}>Cents per kWh</Typography>
      </Box>

      {showLabelX && (
        <Box className={classes.labelX}>
          {type === "bluebonnet-vs-free-weekends" ? (
            <Typography sx={{ fontSize: "10px" }}>Day of the Week</Typography>
          ) : (
            <Typography sx={{ fontSize: "10px" }}>Time of Day</Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

const CustomizedLabel = (props) => {
  const { x, y, stroke, value, pos, setPos } = props;
  if (pos.change) {
    setPos({ x, y, change: false });
  }

  return (
    <>
      <rect id={"sourceDiv"} x={x} y={y} />
    </>
  );
};

interface styleProps {
  x?: number;
  y?: number;
}

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    border: "2px solid #99D7CF",
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
    marginBottom: "2%",
    paddingTop: "30px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "15%",
    },

    [theme.breakpoints.down("md")]: {
      marginBottom: "15%",
    },
  },
  ticks: {
    marginLeft: "0",
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "-6%",
    right: 0,
    width: "100%",
    "& p": {
      color: "#2F2F2F",
    },
    [theme.breakpoints.down("sm")]: {
      bottom: "-9%",
      "& p": {
        fontWeight: 450,
        color: "#979797",
      },
    },
  },
  ticksY: {
    marginLeft: "0%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "-1.5%",
    left: "-4%",
    height: "100%",
    "& p": {
      color: "#2F2F2F",
    },
    [theme.breakpoints.down("sm")]: {
      left: "-6%",
      "& p": {
        fontWeight: 450,
        color: "#979797",
      },
    },
  },
  labelY: {
    marginLeft: "0%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "0%",
    left: "-12%",
    height: "100%",
    transform: "rotate(270deg)",
    "& p": {
      color: "#2F2F2F",
    },
    [theme.breakpoints.down("sm")]: {
      left: "-20%",
      "& p": {
        fontWeight: 450,
        color: "#979797",
      },
    },
    [theme.breakpoints.up(1400)]: {
      left: "-10%",
    },
  },
  labelX: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "-12%",
    right: 0,
    width: "100%",
    "& p": {
      color: "#2F2F2F",
    },
    [theme.breakpoints.down("sm")]: {
      bottom: "-15%",
      "& p": {
        fontWeight: 450,
        color: "#979797",
      },
    },
  },
  val: {
    // flex: 1,
  },
  more: {
    position: "absolute",
    top: (props) => props.y - 100,
    left: "10%",
    "& p": {
      fontSize: 16,
    },
    "& .highlight": {
      fontWeight: "bold",
      color: "#F22824",
    },
    [theme.breakpoints.down("md")]: {
      left: "5%",
      top: (props) => props.y - 45,
      "& p": {
        fontSize: 16,
      },
    },
    [theme.breakpoints.down("sm")]: {
      left: "4%",
      top: (props) => props.y - 55,
      "& p": {
        fontSize: 14,
      },
    },
  },
  save: {
    position: "absolute",
    top: (props) => props.y + 100,
    left: "10%",
    "& p": {
      fontSize: 16,
    },
    "& .highlight": {
      fontWeight: "bold",
      color: "#33AEA0",
    },
    [theme.breakpoints.down("md")]: {
      left: "5%",
      top: (props) => props.y + 20,
      "& p": {
        fontSize: 16,
      },
    },
    [theme.breakpoints.down("sm")]: {
      top: (props) => props.y + 8,
      left: "4%",
      "& p": {
        fontSize: 14,
      },
    },
  },
  logo: {
    position: "absolute",
    top: (props) => props.y - 64,
    right: "4%",
    "& img": {
      width: 44,
      height: "10%",
      objectFit: "contain",
    },
    [theme.breakpoints.down("md")]: {
      right: "5%",
      top: (props) => props.y - 60,
      "& img": {
        width: "5vw",
      },
    },
    [theme.breakpoints.down("sm")]: {
      right: "6%",
      top: (props) => props.y - 55,
      "& img": {
        width: 41,
      },
    },
  },
  recommended: {
    position: "absolute",
    top: (props) => props.y + 10,
    right: "2%",
    "& .highlight": {
      fontWeight: "bold",
      color: "#33AEA0",
    },
    [theme.breakpoints.down("md")]: {
      "& p": {
        fontSize: 16,
      },
    },
    [theme.breakpoints.down("sm")]: {
      top: (props) => props.y + 5,
      "& p": {
        fontSize: 14,
      },
    },
  },
}));
